import { createContext, useContext } from 'react';
import type { TabProps } from './types';

export const DefaultTabsStateConfig = {
  tabs: {} as { [k: string]: TabsState },
};
const DefaultTabsStorageMethods: TabsStorageContextProps = {
  getState() {
    return null;
  },
  setSelectedIndex() {
    return;
  },
  setItems() {
    return;
  },
};
const DefaultTabsStorageContext = { /* ...DefaultTabsStateConfig, */ ...DefaultTabsStorageMethods };
export const TabsStorage = createContext<TabsStorageContextProps>(DefaultTabsStorageContext);
TabsStorage.displayName = 'TabsStorage';

/**
 * Returns TabsStorage context. Re-renders when the provider value changes
 * (e.g. when underlying persisted tab data updates).
 */
export function useDynamicTabsStorage() {
  return useContext(TabsStorage);
}

export type TabsState<TTabProps = TabProps> = {
  selectedIndex: number;
  items: TTabProps[];
};

export interface TabsStorageContextProps<TTabProps = TabProps> {
  getState(tabsID: string): TabsState<TTabProps> | null;
  setSelectedIndex(tabsID: string, index: number): void;
  setItems(tabsID: string, items: TTabProps[]): void;
}
